import Input from "../../../../../../input/Input";
import { BACKSPACE, ENTER } from "../../../../../../../../constants/keyCodes";

const OPTION_VALUE_PREFIX = '- ';

const DishValueCreator = ({
                              autoFocus,
                              index,
                              id,
                              value,
                              onChange,
                              onFocus,
                              onEnter,
                              onBackspace
                          }) => {
    const formatValue = value => `${OPTION_VALUE_PREFIX}${value}`;
    const decodeValue = value => value.substring(2);
    const handleKeyPress = (event) => {
        const {which} = event;
        if (which === ENTER) {
            onEnter(index);
            return;
        }
        if (which === BACKSPACE) {
            onBackspace(index)
        }
    };
    const handleChange = (updatedValue, name) => {
        onChange(decodeValue(updatedValue), name);
    }
    return (
        <Input
            autoFocus={autoFocus}
            id={id}
            value={formatValue(value)}
            onChange={handleChange}
            name={index}
            placeholder="Option value"
            onKeyDown={handleKeyPress}
            onFocus={onFocus}
        />
    );
};

export default DishValueCreator;
